export default {
    domicilios_por_condicao_ocupacao:{
        dados:{
            'alugados' : 'Alugados',
            'cedidos' : 'Cedidos',
            'proprios' : 'Próprios',
            'outra_condicao' : 'Outra Condição',
        },
        data_label: 'Condição de Ocupação',
        title: 'Domicílios por Condição de Ocupação',
        uses_subheader: true,
        total_from_rows: true,
        censo: 2010
    },
    domicilios_por_faixa_de_renda: {
        dados:{
            'ate_um_salario' : 'Até 1 Salário',
            'de_1_a_2_salarios' : 'De 1 a 2 Salários',
            'de_2_a_3_salarios' : 'De 2 a 3 Salários',
            'de_3_a_5_salarios' : 'De 3 a 5 Salários',
            'de_5_a_10_salarios' : 'De 5 a 10 Salários',
            'mais_de_10_salarios' : 'Mais de 10 Salários',
        },
        data_label: 'Faixas de Renda',
        title: 'Domicílios por Faixa de Renda',
        uses_subheader: true,
        censo: 2010
    },
    domicilios_por_numero_moradores: {
        dados:{
            'um_moradores' : '1 Morador',
            'dois_moradores' : '2 Moradores',
            'tres_moradores' : '3 Moradores',
            'quatro_moradores' : '4 Moradores',
            'cinco_moradores' : '5 Moradores',
            'seis_moradores' : '6 Moradores',
            'sete_moradores' : '7 Moradores',
            'oito_moradores' : '8 Moradores',
            'nove_moradores' : '9 Moradores',
            'dez_moradores' : '10 Moradores',
        },
        data_label: 'Número de Moradores',
        title: 'Domicílios por Número de Moradores',
        uses_subheader: true,
        censo: 2010
    },
    domicilios_por_tipo_moradia:{
        dados:{
            'apartamentos' : 'Apartamentos',
            'casas' : 'Casas',
        },
        data_label: 'Tipos de Moradia',
        title: 'Domicílios por Tipo de Moradia',
        uses_subheader: true,
        censo: 2010
    },
    indice_verticalizacao: {
        dados:{
            'apartamentos' : 'Apartamentos',
            'indice_verticalizacao' : 'Índice de Verticalização',
        },
        data_label: 'Tipos de Moradia',
        title: 'Índice de Verticalização',
        uses_subheader: false,
        censo: 2010
    },
    faixa_etaria:{
        dados: {
            total_0_19: 'de 0 a 19 anos',
            total_20_24: 'de 20-24',
            total_25_34: 'de 25-34',
            total_35_49: 'de 35-49',
            total_50_59: 'de 50-59',
            total_60_mais: 'mais de 60',
        },
        data_label: 'Faixas Etárias',
        title: 'População por Faixa Etária',
        uses_subheader: true,
        censo: 2010
    },
    populacao_por_faixa_de_renda:{
        dados:{
            'ate_um_salario' : 'Até 1 Salário',
            'de_1_a_2_salarios' : 'De 1 a 2 Salários',
            'de_2_a_3_salarios' : 'De 2 a 3 Salários',
            'de_3_a_5_salarios' : 'De 3 a 5 Salários',
            'de_5_a_10_salarios' : 'De 5 a 10 Salários',
            'de_10_a_15_salarios' : 'De 10 a 15 Salários',
            'de_15_a_20_salarios' : 'De 15 a 20 Salários',
            'mais_de_20_salarios' : 'Mais de 20 Salários',
        },
        data_label: 'Faixas de Renda',
        title: 'População por Faixa de Renda',
        uses_subheader: true,
        censo: 2010
    },
    'mapa_coropetico_renda_domiciliar':{
        title: 'Mapa coropético - Renda Média Domiciliar',
        dados_info_window: [{
            type: 'currency',
            field: 'renda_media_domiciliar',
            label: 'Renda Média Domiciliar'
        }],
        dado_range: 'renda_media_domiciliar',
        dado_type : 'currency',
        color_ranges: [
            { min: 0, max: 1525, color: '#FB7574' },
            { min: 1525.01, max: 2713, color: '#FDBCBA' },
            { min: 2713.01, max: 4607, color: '#E6D0B9' },
            { min: 4607.01, max: 8150, color: '#FEDB37' },
            { min: 8150.01, max: 16186, color: '#FEF6B8' },
            { min: 16186.01, max: 28096, color: '#38963E' },
            { min: 28096.01, max: Infinity, color: '#1F5823' }
        ],
        censo: 2010
    }
    ,'mapa_coropetico_indice_verticalizacao': {
        title: 'Mapa coroplético - Indíce de Verticalização',
        dados_info_window: [
            {
                type: 'percentage',
                field: 'indice_verticalizacao',
                label: 'Indíce de Verticalização'
            },
            {
                type: 'integer',
                field: 'apartamentos',
                label: 'Número de Apartamentos'
            },
            {
                type: 'integer',
                field: 'casas',
                label: 'Número de Casas'
            },
            {
                type: 'integer',
                field: 'total',
                label: 'Total de Moradias'
            },
        ],
        dado_range: 'indice_verticalizacao',
        dado_type : 'percentage',
        color_ranges: [
            { min: 0, max: 9.99, color: '#FDF3B6' },
            { min: 10, max: 19.99, color: '#FFE378' },
            { min: 20, max: 39.99, color: '#FEC536' },
            { min: 40, max: 59.99, color: '#FDA333' },
            { min: 60, max: 79.99, color: '#F5892F' },
            { min: 80, max: 100, color: '#884031'   },
        ],
        censo: 2010
    },
    'mapa_coropetico_indice_propriedade': {
        title: 'Mapa coroplético - Indíce de Propriedade',
        dados_info_window: [
            {
                type: 'percentage',
                field: 'indice_propriedade',
                label: 'Indíce de Propriedade'
            },
            {
                type: 'integer',
                field: 'proprios',
                label: 'Número de domicílios  Próprios'
            },
            {
                type: 'integer',
                field: 'alugados',
                label: 'Número de domicílios Alugados'
            },
            {
                type: 'integer',
                field: 'cedidos',
                label: 'Número de domicílios Cedidos'
            }
            ,{
                type: 'integer',
                field: 'total',
                label: 'Número Total de Domílios'
            },

        ],
        dado_range: 'indice_propriedade',
        dado_type : 'percentage',
        color_ranges: [
            { min: 0, max: 30, color: '#FEF6B8'     },
            { min: 30.01, max: 50, color: '#D2E8FF'  },
            { min: 50.01, max: 65, color: '#74D0FF'  },
            { min: 65.01, max: 80, color: '#1E77D1'  },
            { min: 80.01, max: 100, color: '#341A49' },
        ],
        censo: 2010
    },
    'mapa_coropetico_densidade_demografica_2010': {
        title: 'Mapa coroplético - Densidade Demográfica 2010',
        dados_info_window: [
            {
                type: 'double',
                field: 'densidade_demografica',
                label: 'Densidade Demográfica - hab/km²'
            },
            {
                type: 'integer',
                field: 'populacao',
                label: 'População'
            },
            {
                type: 'km2',
                field: 'area_km2',
                label: 'Área em km²'
            },

        ],
        dado_range: 'densidade_demografica',
        dado_type : 'double',
        color_ranges: [
            { min: 0, max: 1000, color: '#FDB9BA'        },
            { min: 1000.01, max: 5000, color: '#FC7778'  },
            { min: 5000.01, max: 10000, color: '#FB282E' },
            { min: 10000.01, max: 15000, color: '#D1262C'},
            { min: 15000.01, max: 25000, color: '#A32226'},
            { min: 25001, max: Infinity, color: '#772122' },
        ],
        censo: 2010
    }
    ,'mapa_coropetico_densidade_demografica_2022': {
        title: 'Mapa coroplético - Densidade Demográfica 2022',
        dados_info_window: [
            {
                type: 'double',
                field: 'densidade_demografica',
                label: 'Densidade Demográfica - hab/km²'
            },
            {
                type: 'integer',
                field: 'populacao',
                label: 'População'
            },
            {
                type: 'km2',
                field: 'area_km2',
                label: 'Área em km²'
            },
        ],
        dado_range: 'densidade_demografica',
        dado_type : 'double',
        color_ranges: [
            { min: 0, max: 1000, color: '#FDB9BA'        },
            { min: 1000.01, max: 5000, color: '#FC7778'  },
            { min: 5000.01, max: 10000, color: '#FB282E' },
            { min: 10000.01, max: 15000, color: '#D1262C'},
            { min: 15000.01, max: 25000, color: '#A32226'},
            { min: 25001, max: Infinity, color: '#772122' },
        ],
        censo: 2022
    },
    faixa_etaria2022:{
        dados: {
            '0_a_4_anos' : '0 a 4 anos',
            '5_a_9_anos' : 'de 5-9',
            '10_a_14_anos' : 'de 10-14',
            '15_a_19_anos' : 'de 15-19',
            '20_a_24_anos' : 'de 20-24',
            '25_a_29_anos' : 'de 25-29',
            '30_a_39_anos' : 'de 30-39',
            '40_a_49_anos' : 'de 40-49',
            '50_a_59_anos' : 'de 50-59',
            '60_a_69_anos' : 'de 60-69',
            '70_anos_ou_mais' : '70 anos ou mais',
        },
        data_label: 'Faixas Etárias - Censo 2022',
        title: 'População por Faixa Etária - Censo 2022',
        uses_subheader: true,
        censo: 2022
    },
    populacao_por_faixa_etaria:{
        dados: {
            'nr_populacao_0_4_anos_v01031' : '0 a 4 anos',
            'nr_populacao_5_9_anos_v01032' : 'de 5-9',
            'nr_populacao_10_14_anos_v01033' : 'de 10-14',
            'nr_populacao_15_19_anos_v01034' : 'de 15-19',
            'nr_populacao_20_24_anos_v01035' : 'de 20-24',
            'nr_populacao_25_29_anos_v01036' : 'de 25-29',
            'nr_populacao_30_39_anos_v01037' : 'de 30-39',
            'nr_populacao_40_49_anos_v01038' : 'de 40-49',
            'nr_populacao_50_59_anos_v01039' : 'de 50-59',
            'nr_populacao_60_69_anos_v01040' : 'de 60-69',
            'nr_populacao_70_anos_mais_v01041' : '70 anos ou mais',
        },
        data_label: 'Faixas Etárias',
        title: 'População por Faixa Etária',
        uses_subheader: true,
        total_from_rows: true,
    },
    populacao_por_estado_civil:{
        dados: {
            'casadas' : 'Casadas',
            'solteiras' : 'Solteiras',
            'separadas_divorciadas_viuvas' : 'Separadas, divorciadas ou viúvas',
        },
        data_label: 'Estado Civil',
        title: 'População por Estado Civil',
        uses_subheader: true,
        total_from_rows: true,
        more_info: 'Dados do Censo 2022.',
    },
    populacao_por_genero:{
        dados: {
            'masculino' : 'Masculino',
            'feminino' : 'Feminino',
        },
        data_label: 'Gênero',
        title: 'População por Gênero',
        uses_subheader: true,
        total_from_rows: true,
        more_info: 'Dados do Censo 2022.',
    },
    domicilios_por_tipo_moradia_simplificado:{
        dados:{
            'casa' : 'Casa',
            'apartamento' : 'Apartamento',
            'outros_tipos' : 'Outros Tipos',
        },
        data_label: 'Tipo de Moradia',
        title: 'Domicílios por Tipo de Moradia',
        uses_subheader: true,
        total_from_rows: true,
        more_info: 'Casa inclui casas de vila ou condomínio. Outros tipos abrange habitação em estrutura degradada, cortiço, maloca, etc. Dados do Censo 2022.',
        censo: 2022
    },
    domicilios_por_tipo_moradia2022:{
        dados:{
            'casa' : 'Casa',
            'casa_condominio' : 'Casa de vila ou condomínio',
            'apartamento' : 'Apartamento',
            'cortico' : 'Cortiço',
            'inacabada' : 'Estrutura degradada ou inacabada',
            'maloca' : 'Maloca',
        },
        data_label: 'Tipos de Moradia - Censo 2022',
        title: 'Domicílios por Tipo de Moradia - Censo 2022',
        uses_subheader: true,
        more_info: 'Os dados se referem apenas aos domicílios particulares permanentes ocupados',
        censo: 2022
    },
    indice_verticalizacao2022: {
        dados:{
            'apartamento' : 'Apartamentos',
            'indice_verticalizacao' : 'Índice de Verticalização',
        },
        data_label: 'Tipos de Moradia - Censo 2022',
        title: 'Índice de Verticalização - Censo 2022',
        uses_subheader: false,
        more_info: 'Os dados se referem apenas aos domicílios particulares permanentes ocupados',
        censo: 2022
    },
    'mapa_coropetico_indice_verticalizacao2022': {
        title: 'Mapa coroplético - Indíce de Verticalização - Censo 2022',
        dados_info_window: [
            {
                type: 'percentage',
                field: 'indice_verticalizacao',
                label: 'Indíce de Verticalização'
            },
            {
                type: 'integer',
                field: 'apartamentos',
                label: 'Número de Apartamentos'
            },
            {
                type: 'integer',
                field: 'total',
                label: 'Total de Moradias'
            },
        ],
        dado_range: 'indice_verticalizacao',
        dado_type : 'percentage',
        color_ranges: [
            { min: 80, max: 100, color: '#7a2811'   },
            { min: 60, max: 79.99, color: '#826c6e' },
            { min: 40, max: 59.99, color: '#d2b48c' },
            { min: 1, max: 39.99, color: '#ffdeb3'  },
            { min: 0.1, max: 0.99, color: '#f5f5dc' },
            { min: 0, max: 0, color:  '#bbbbbb'     },
        ],
        censo: 2022
    },

    domicilios_por_numero_moradores2022: {
        dados:{
            'um_moradores' : '1 Morador',
            'dois_moradores' : '2 Moradores',
            'tres_moradores' : '3 Moradores',
            'quatro_moradores' : '4 Moradores',
            'cinco_moradores' : '5 Moradores',
            'seis_moradores' : '6 Moradores',
            'sete_moradores' : '7 Moradores',
            'oito_moradores' : '8 Moradores',
            'nove_moradores' : '9 Moradores',
            'dez_moradores' : '10 ou mais Moradores',
        },
        data_label: 'Número de Moradores',
        title: 'Domicílios por Número de Moradores - Censo 2022',
        uses_subheader: true,
        censo: 2022,
        more_info: 'Os dados se referem apenas aos domicílios particulares permanentes ocupados',
    },
    'renda_consumo' : {
        title: 'Renda e Consumo',
    },
    projecao_domicilios: {
        dados: {
            'nr_domicilios_2010': '2010',
            'nr_domicilios_2022': '2022',
            'nr_domicilios_proj_2026': '2026',
            'nr_domicilios_proj_2027': '2027',
            'nr_domicilios_proj_2028': '2028',
            'nr_domicilios_proj_2029': '2029',
            'nr_domicilios_proj_2030': '2030',
            'nr_domicilios_proj_2031': '2031',
        },
        data_label: 'Ano',
        title: 'Projeção de Domicílios',
        uses_subheader: false,
        hide_percentage: true,
        datalayerName: 'projecao_domicilios',
        more_info: 'Projeção baseada na taxa de crescimento anual composta entre os Censos de 2010 e 2022.',
    },
    crescimento_domicilios: {
        dados: {
            'crescimento_2026': '2026',
            'crescimento_2027': '2027',
            'crescimento_2028': '2028',
            'crescimento_2029': '2029',
            'crescimento_2030': '2030',
            'crescimento_2031': '2031',
            'media_domicilios_proj': 'Média',
        },
        data_label: 'Localidade',
        title: 'Crescimento Anual dos Domicílios: 2026 a 2031',
        uses_subheader: false,
        hide_percentage: true,
        more_info: 'Projeção baseada na taxa de crescimento anual composta entre os Censos de 2010 e 2022.',
    },
    domicilios_numero_moradores: {
        dados: {
            '1_morador':           '1 morador',
            '2_moradores':         '2 moradores',
            '3_moradores':         '3 moradores',
            '4_moradores':         '4 moradores',
            '5_ou_mais_moradores': '5 ou mais moradores',
        },
        data_label: 'Número de Moradores',
        title: 'Domicílios por Número de Moradores',
        uses_subheader: true,
        total_from_rows: true,
        more_info: 'Dados do Censo 2022.',
    },
    domicilios_faixa_renda: {
        dados: {
            'acima_de_42267':   'Acima de R$ 42.267,00',
            'de_39470_a_42267': 'R$ 39.470,01 a R$ 42.267,00',
            'de_36511_a_39470': 'R$ 36.511,01 a R$ 39.470,00',
            'de_27320_a_36511': 'R$ 27.320,01 a R$ 36.511,00',
            'de_20983_a_27320': 'R$ 20.983,01 a R$ 27.320,00',
            'de_17147_a_20983': 'R$ 17.147,01 a R$ 20.983,00',
            'de_14590_a_17147': 'R$ 14.590,01 a R$ 17.147,00',
            'de_10775_a_14590': 'R$ 10.775,01 a R$ 14.590,00',
            'de_7716_a_10775':  'R$ 7.716,01 a R$ 10.775,00',
            'de_6200_a_7716':   'R$ 6.200,01 a R$ 7.716,00',
            'de_3587_a_6200':   'R$ 3.587,01 a R$ 6.200,00',
            'de_1912_a_3587':   'R$ 1.912,01 a R$ 3.587,00',
            'de_1621_a_1912':   'R$ 1.621,01 a R$ 1.912,00',
            'abaixo_de_1621':   'Abaixo de R$ 1.621,00',
        },
        data_label: 'Rendimento Familiar',
        title: 'Domicílios por faixa de rendimento familiar',
        uses_subheader: true,
        total_from_rows: true,
        more_info: null,
        footer_fields: [
            { key: 'renda_media_domiciliar', label: 'Média de Renda', format: 'currency' },
        ],
    }
}
